import Api from '../../../helpers/Api';

export const SET_SENTENCE = 'SET_SENTENCE';
const setSentence = (data) => ({
    type: SET_SENTENCE,
    data,
});


export const getSentenceIfNeeded = () => (dispatch, getState) => {
    const sentenceId = getState().daysSentence.sentenceData.id;

    // TODO (one day) add a last updated timestamp and check for new sentence if older than x minutes
    if (!sentenceId) {
        const url = 'api/v1/getDaysSentence';

        return Api.progressGet(dispatch, url)
            .then((json) => {
                if (json.status !== 'success') {
                    throw `error from server: ${json.message}`;
                } else {
                    return dispatch(setSentence(json.data));
                }
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('getSentence got error:', error);
            });
    }

    return Promise.resolve(1);
};
